import { render, staticRenderFns } from "./CommonChart.vue?vue&type=template&id=33973f6b"
import script from "./CommonChart.vue?vue&type=script&lang=js"
export * from "./CommonChart.vue?vue&type=script&lang=js"
import style0 from "./CommonChart.vue?vue&type=style&index=0&id=33973f6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports